var _circle, _circle2, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeminine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    fill: "#D9DBE3",
    stroke: "#D9DBE3",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2575_11657",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 46,
    height: 46
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 23,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2575_11657)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8942 42.6163C39.1237 42.6166 40.3254 42.9815 41.3474 43.6648C42.3695 44.348 43.166 45.319 43.6363 46.4549C44.1065 47.5908 44.2294 48.8407 43.9894 50.0464C43.7493 51.2522 43.1572 52.3597 42.2877 53.2289C41.4183 54.0981 40.3106 54.69 39.1048 54.9298C37.899 55.1695 36.6492 55.0463 35.5134 54.5757C34.3776 54.1052 33.4068 53.3084 32.7238 52.2862C32.0408 51.2639 31.6763 50.0621 31.6763 48.8327C31.6763 48.0162 31.8371 47.2077 32.1496 46.4534C32.4621 45.6991 32.9202 45.0138 33.4976 44.4365C34.075 43.8592 34.7605 43.4014 35.5148 43.0891C36.2692 42.7768 37.0778 42.6161 37.8942 42.6163Z",
    fill: "#7581F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0913 51.0624C30.8811 48.4577 27.3472 35.7819 27.2917 34.3858C27.2371 33.004 27.7337 31.6571 28.6723 30.6414C29.6108 29.6257 30.9144 29.0245 32.2962 28.9699C33.678 28.9154 35.025 29.412 36.0406 30.3505C37.0563 31.2891 37.6576 32.5927 37.7121 33.9745C37.7995 36.125 43.3408 43.3451 43.9872 47.5397C44.9148 53.5654 32.7314 52.4362 32.0913 51.0576",
    fill: "#FAAA5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8942 42.6163C39.1237 42.6166 40.3254 42.9815 41.3474 43.6648C42.3695 44.348 43.166 45.319 43.6363 46.4549C44.1065 47.5908 44.2294 48.8407 43.9894 50.0464C43.7493 51.2522 43.1572 52.3597 42.2877 53.2289C41.4183 54.0981 40.3106 54.69 39.1048 54.9298C37.899 55.1695 36.6492 55.0463 35.5134 54.5757C34.3776 54.1052 33.4068 53.3084 32.7238 52.2862C32.0408 51.2639 31.6763 50.0621 31.6763 48.8327C31.6763 48.0162 31.8371 47.2077 32.1496 46.4534C32.4621 45.6991 32.9202 45.0138 33.4976 44.4365C34.075 43.8592 34.7605 43.4014 35.5148 43.0891C36.2692 42.7768 37.0778 42.6161 37.8942 42.6163Z",
    fill: "#7581F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4093 51.787C45.6277 62.1884 34.5561 54.4648 33.7127 53.434C31.5098 49.8684 33.0901 50.7086 32.8503 48.4596C32.7267 47.6668 32.7692 46.8569 32.9751 46.0814C33.181 45.3058 33.5458 44.5815 34.0463 43.9544C34.5468 43.3272 35.1722 42.8109 35.8828 42.4381C36.5933 42.0654 37.3736 41.8443 38.1741 41.789C39.5686 41.6 42.4973 41.3125 44.5731 41.8986C44.697 41.9288 44.8209 41.9621 44.9432 42.0003C48.7311 43.1883 50.9182 47.6306 49.4093 51.7822",
    fill: "#FAAA5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2622 47.0062C41.0037 46.9061 39.1597 48.2958 39.147 50.1112C39.1343 51.9266 40.9545 53.4799 43.2129 53.5799C45.4714 53.68 47.3169 52.2903 47.3297 50.4749C47.3424 48.6595 45.5143 47.1062 43.2622 47.0062Z",
    fill: "#FAAA5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7521 43.9187C41.492 43.8186 39.6496 45.2099 39.6353 47.0252C39.621 48.8406 41.4428 50.3923 43.7028 50.4924C45.9629 50.5924 47.8052 49.2027 47.8195 47.3874C47.8338 45.572 46.0121 44.0203 43.7521 43.9187Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8521 38.1294L36.13 38.5027C36.5024 38.9919 36.762 39.5575 36.8902 40.1588C37.0185 40.7601 37.0121 41.3823 36.8718 41.9809C36.6033 43.0736 36.0062 44.5031 34.7324 46.1659C35.6853 48.6547 36.7113 53.4719 33.8303 55.4222C32.7185 56.1766 20.1396 57.0105 15.907 56.0766C13.3848 55.5191 13.2213 53.6529 14.5316 50.8608C15.2256 49.3805 12.74 40.9041 11.6473 37.3512C10.7669 36.8827 10.0684 36.1332 9.66296 35.2219C9.25751 34.3107 9.16839 33.2901 9.40977 32.3224C9.65115 31.3547 10.2092 30.4955 10.9951 29.8814C11.781 29.2674 12.7496 28.9337 13.747 28.9335C13.9281 28.9344 14.109 28.9466 14.2886 28.9701C22.7364 28.9701 29.0814 29.1702 32.2929 29.0431C33.6662 28.9806 35.0082 29.4656 36.0243 30.3917C37.0403 31.3178 37.6473 32.6093 37.7119 33.9826C37.7432 34.7709 37.5915 35.5558 37.2689 36.2758C36.9462 36.9957 36.4613 37.6313 35.8521 38.1326",
    fill: "#FAAA5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.051 36.3094C29.4259 37.3878 29.7181 38.3947 29.7959 39.084C30.0357 41.2202 29.6371 45.6197 28.7524 53.9357",
    stroke: "black",
    strokeWidth: 0.453984,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8301 55.4224C36.7111 53.4736 35.6804 48.6549 34.7322 46.1661C36.0028 44.5032 36.6031 43.0738 36.8716 41.9811C37.012 41.3825 37.0183 40.7602 36.89 40.1589C36.7618 39.5576 36.5022 38.9921 36.1299 38.5028C35.4247 37.5594 34.2351 35.9775 32.3657 33.5189",
    stroke: "black",
    strokeWidth: 0.453984,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5048 35.8282C15.4543 40.1165 13.3833 43.0611 13.1927 49.6856C13.0767 53.7261 15.2383 54.6806 13.685 59.0562C11.938 63.9607 -0.369299 63.8956 0.0881145 56.4674C0.578881 48.5087 8.05314 34.5179 9.66044 31.5892C9.91181 31.027 10.2766 30.5229 10.7318 30.1082C11.1871 29.6936 11.7231 29.3775 12.3062 29.1796C12.8894 28.9817 13.5071 28.9064 14.1207 28.9584C14.7343 29.0103 15.3305 29.1885 15.8721 29.4815C16.4136 29.7746 16.8888 30.1764 17.2679 30.6617C17.647 31.147 17.9218 31.7053 18.075 32.3017C18.2283 32.8981 18.2568 33.5197 18.1586 34.1276C18.0605 34.7356 17.8379 35.3167 17.5048 35.8346",
    fill: "#FAAA5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1948 38.644C13.6537 43.7582 13.1883 45.8086 13.1089 49.433",
    stroke: "black",
    strokeWidth: 0.453984,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6418 16.7358C20.4613 16.8499 20.3323 17.0298 20.2822 17.2373C20.2321 17.4449 20.2648 17.6638 20.3734 17.8476C20.4335 17.9326 20.51 18.0046 20.5984 18.0594C20.6868 18.1143 20.7854 18.1508 20.8882 18.1668C20.991 18.1828 21.096 18.1779 21.1969 18.1526C21.2978 18.1272 21.3926 18.0818 21.4756 18.0191",
    stroke: "black",
    strokeWidth: 0.453984,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6042 18.2208C31.716 14.5536 26.6701 17.2044 24.696 18.772C22.7218 20.3396 23.0553 24.0465 25.4424 27.0499C27.8296 30.0532 34.7543 32.6897 35.3483 30.2407C36.9524 23.6209 29.0922 23.1714 30.6042 18.2208Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0944 22.4504L28.4417 28.2745C28.4526 28.3137 28.4574 28.3544 28.456 28.3952C28.4099 29.0622 26.3913 29.3291 23.9343 28.9923C21.4772 28.6556 19.5285 27.8425 19.5745 27.177C19.5821 27.1067 19.6096 27.04 19.6539 26.9848L22.219 18.5004L29.0944 22.4504Z",
    fill: "#4676FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7368 26.2114C23.5321 24.5676 23.3765 19.5408 23.3765 19.5408L29.1021 22.3615L28.7368 26.2114Z",
    fill: "#2047AE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9245 19.1309C10.5861 22.1962 21.394 7.69558 24.9946 7.37793C24.9946 7.37793 30.3501 7.43511 31.7938 10.6751C32.1035 11.8425 32.0416 12.5222 32.4657 14.344C33.1105 17.1027 32.7357 22.1168 29.4591 23.1412C27.5437 23.74 24.0829 23.3556 21.9245 19.1341",
    fill: "#4676FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.688 18.2701C26.688 18.2701 28.0888 20.1474 30.0233 19.2945",
    stroke: "black",
    strokeWidth: 0.453984,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2222 18.818C27.3786 18.6315 27.5824 18.4906 27.8122 18.4101C28.0419 18.3296 28.2891 18.3125 28.5277 18.3606C29.0709 18.4464 29.1979 18.7894 29.1979 18.7894C29.1979 18.7894 30.0635 18.3003 30.1684 19.2977C29.6172 19.8536 27.8019 19.5391 27.2222 18.8212",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5776 12.7287C29.5776 12.7287 30.5481 11.9711 32.0076 12.5953",
    stroke: "black",
    strokeWidth: 0.453984,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.606 13.9979L31.362 13.5198",
    stroke: "black",
    strokeWidth: 0.453984,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9272 14.0722L26.7785 13.6704",
    stroke: "black",
    strokeWidth: 0.453984,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5679 13.2768C25.0316 12.8892 26.3705 12.0713 27.8889 12.7876",
    stroke: "black",
    strokeWidth: 0.453984,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0957 13.7327C29.0421 14.1113 29.087 14.4972 29.2261 14.8533C29.3652 15.2094 29.5938 15.5237 29.8898 15.7657C30.8983 16.6154 30.5029 17.9749 29.0957 17.7764",
    stroke: "black",
    strokeWidth: 0.453984,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7276 17.2364L19.936 16.3199",
    stroke: "black",
    strokeWidth: 0.453984,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8668 14.0199C26.1082 13.9786 26.3337 14.2677 26.3703 14.6663C26.4068 15.065 26.24 15.4239 25.9986 15.4605C25.7572 15.497 25.5333 15.2127 25.4967 14.8125C25.4602 14.4122 25.627 14.0564 25.8668 14.0183",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6998 13.8059C30.9396 13.7646 31.1652 14.0537 31.2017 14.4523C31.2382 14.851 31.0731 15.2083 30.8317 15.2465C30.5902 15.2846 30.3663 14.9987 30.3298 14.5985C30.2932 14.1982 30.4584 13.8425 30.6998 13.8043",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4634 29.1162C12.4634 29.1162 15.0046 29.1162 17.0375 29.1162C20.492 30.7823 20.5317 35.8408 18.3987 37.1368H27.0085C28.5856 34.5591 28.619 32.5087 27.8916 30.903C29.9182 32.8613 30.0452 34.8831 27.4151 37.0971C39.5874 33.522 28.4395 27.8663 21.7689 26.2367C21.2847 26.0627 20.7917 25.9142 20.2918 25.792C20.2918 25.792 24.1036 22.7585 21.8642 18.9086C21.032 19.4549 19.9297 18.8816 19.6121 18.4877C18.8672 17.5602 18.9005 16.1053 19.7566 15.5653C20.6127 15.0253 21.6196 15.4986 22.2025 16.0831C22.2263 16.1085 22.2914 16.1752 22.3137 16.207C21.5926 13.2243 27.2182 11.5185 26.4113 8.65649C26.4113 8.65649 29.7212 8.2229 31.7081 10.5624C31.7192 9.5062 30.7186 6.9666 26.5019 6.17724C21.5783 5.25606 16.9549 7.98149 17.1868 13.0511C17.1566 13.4228 17.2662 13.8548 16.9549 14.5028C16.0465 16.3912 3.17218 24.6501 12.4697 29.1146L12.4634 29.1162ZM27.3802 37.1305L27.4103 37.0971L27.3611 37.1305H27.3802Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeminine);
export default __webpack_public_path__ + "static/media/feminine.06813b24c74f461abb5986694105281d.svg";
export { ForwardRef as ReactComponent };